import React, { useEffect } from 'react';
import { CustomIcon } from '../../UI';
import './ResponseModal.scss';

const ResponseModal = ({ 
  isOpen, 
  message, 
  status, 
  onClose,
  title 
}) => {
  // Show modal if isOpen is explicitly set, or if message and status are provided
  const shouldShow = isOpen !== undefined ? isOpen : !!(message && status);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    if (shouldShow) {
      document.body.classList.add('modal-open');
      return () => {
        document.body.classList.remove('modal-open');
      };
    }
  }, [shouldShow]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && shouldShow) {
        handleClose();
      }
    };

    if (shouldShow) {
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [shouldShow, handleClose]);

  if (!shouldShow) return null;

  const isSuccess = status === 'success';
  const defaultTitle = isSuccess ? 'Success!' : 'Something went wrong!';

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div 
      className="response-modal-overlay" 
      onClick={handleOverlayClick}
    >
      <div 
        className={`response-modal ${status}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          className="response-modal__close-btn"
          onClick={handleClose}
          aria-label="Close modal"
        >
          <CustomIcon name="close" size={20} />
        </button>

        {/* Status Icon */}
       <div className='response-modal__wrapper'>
         <div className={`response-modal__icon ${status}`}>
          {isSuccess ? (
            <CustomIcon name="success" color='currentColor' size={116}/>
          ) : (
            <CustomIcon name="error" color='currentColor' size={116}/>
          )}
        </div>

        {/* Title */}
        <h2 className="response-modal__title">
          {title || defaultTitle}
        </h2>

        {/* Message */}
        <p className="response-modal__message">
          {message}
        </p>

        {/* Close Button */}
        <button 
          className={`response-modal__action-btn ${status}`}
          onClick={handleClose}
        >
          Close
        </button>
       </div>
      </div>
    </div>
  );
};

export default ResponseModal;
